export enum RedirectsQueryKeys {
  GetAll = 'redirects/getAll',
  GetAllList = 'redirects/getAllList',
  Conflicts = 'redirects/conflicts',
  PagesPaths = 'redirects/pagesPaths',
  Dossier = 'redirects/dossier',
  Create = 'redirects/create',
  Edit = 'redirects/edit',
  Delete = 'redirects/delete',
  Breadcrumb = 'redirects/breadcrumb',
  BulkCreateByPages = 'redirects/bulkCreateByPages',
  BulkCreateByPaths = 'redirects/bulkCreateByPaths',
  BulkActivity = 'redirects/bulkActivity',
  BulkDelete = 'redirects/bulkDelete',
}
